export interface Testimonial {
	quote: string;
	author: string;
	role: string;
	marketName: string;
	subdomain: string;
}

export const testimonials: Testimonial[] = [
	{
		quote:
			"I have been using LocallyGrown to augment our farmer's market since 2013 and have found it to be a great tool to increase our sales. It is simple to use, has great reporting features, works flawlessly and has great support.",
		author: 'Bob Gregory',
		role: 'Manager',
		marketName: 'Berea Gardens',
		subdomain: 'bereagardens',
	},
	{
		quote:
			"This platform has always felt like a true farmers' market except that we come to the customers online. The biggest plus is how quickly Eric always responds to any and all questions. I love that this is a labor of love for him, and not just a corporate desk job.",
		author: 'Pamela Bowshier',
		role: 'Manager',
		marketName: 'Champaign Locally Grown',
		subdomain: 'champaignoh',
	},
	{
		quote:
			"LocallyGrown has been a solid platform for us for the past 7 or 8 years. I really appreciate that I don't have to take a lot of time away from farm duties to fuss with a webpage; LocallyGrown is straightforward, and I can do what needs to be done in just a few minutes. The price is also great!",
		author: 'Greta Marlow',
		role: 'Manager',
		marketName: 'Foothills Market',
		subdomain: 'foothillsmarket',
	},
	{
		quote: 'I recommend it for ease of use, fair price and great customer service.',
		author: 'Michelle Pridgen',
		role: 'Manager',
		marketName: 'Independence Farmers Market',
		subdomain: 'independencefarmersmarket',
	},
	{
		quote:
			"We chose LocallyGrown because it's affordable. We stayed because it looks great and is user friendly. I don't know of many companies that respond to problems as quickly or thoroughly as LocallyGrown.",
		author: 'Shawn Boucher',
		role: 'Manager',
		marketName: 'Independence Farmers Market',
		subdomain: 'independencefarmersmarket',
	},
	{
		quote:
			"Our market chose Locally Grown because we needed a reliable online market that could go live quickly and was flexible enough to meet our specific needs. We especially appreciate Eric's timely responsiveness to our questions and support needs.",
		author: 'Teresa Maurer',
		role: 'Market Assistant',
		marketName: "Fayetteville Farmers' Market",
		subdomain: 'fayettevillearkansas',
	},
];
